module.exports = __webpack_public_path__ + "static/img/sx_ytg.cfce9a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sx_ytg.png
// module id = 1WxE
// module chunks = 167